import React from 'react';

import { useTranslate } from 'src/shared/hooks';
import { External } from 'src/shared/route';

import { LargerThanMobile } from './LargerThanMobile';
import { Mobile } from './Mobile';

const Navigation = () => {
  const t = useTranslate('common');

  const links = [
    { label: t('navigation.product'), path: External.PRODUCT.path },
    { label: t('navigation.pricing'), path: External.PRICING.path },
    { label: t('navigation.careers'), path: External.CAREERS.path },
  ];

  return (
    <>
      <LargerThanMobile links={links} />
      <Mobile links={links} />
    </>
  );
};

export { Navigation };
